<template>
    <div class="wrap">
        <div class="container lnb" style="position: relative">
            <div class="contents_wrap" style="height: 100%;">
                <div class="contents">
                    <div class="title">
                        {{ this.$route.meta.title }}
                        <div class="clear"></div>
                    </div>
                    <div style="min-height: calc(100vh - 374px)">
                        <lookbook-item-component :lookbookKey="lookbookKey"></lookbook-item-component>
                        <div style="text-align: center; padding: 30px">
                            <el-button @click="submitForm()" type="primary">저장</el-button>
                            <el-button style="float: right;"
                                       @click="$modal.show('lookbook-item-create-modal',{lookbookKey:lookbookKey})"
                                       type="success">엑셀등록
                            </el-button>
                        </div>
                    </div>

                </div>
            </div>


            <page-footer></page-footer>
        </div>
        <lookbook-item-modal></lookbook-item-modal>
        <lookbook-item-create-modal></lookbook-item-create-modal>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus";
import LookbookWriteComponent from "@/components/lookbook/LookbookWriteComponent";
import LookbookItemModal from "@/components/modal/LookbookItemModal";
import LookbookItemComponent from "@/components/lookbook/LookbookItemComponent";
import LookbookItemCreateModal from "@/components/modal/LookbookItemCreateModal";

export default {
    name: 'LookbookUseItem',
    components: {
        LookbookItemCreateModal,
        LookbookItemComponent,
        LookbookItemModal,
    },
    mixins: [],
    data() {
        return {
            lookbookKey: this.$route.params.l_idx
        }
    },
    mounted() {
    },
    methods: {
        submitForm() {
            EventBus.$emit('writeLookbookItem');
        },
    },
    watch: {}
}
</script>

<style lang="scss" scoped>

</style>
